import moment from 'moment';

export const params = () => {
    return {
        branch_office_id: null,
        branch_office_warehouse_id: null,
        dates: [
            moment().add('month', -1).format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
        ],
        voucher_type_id: null,
        model_id: null,
        contact_id: null,
        state_id: null,
        paginate: 1,
        per_page: 15,
        page: 1
    };
};


export default {
    documents: {
        data: []
    },
    modal: {
        show: false
    },
    params_contacts: {
        only_active: true,
        filter: '',
        type: 'is_customer',
        is_customer: true,
        paginate: false,
        contact_id: null
    },
    preloader: false,
    branch_offices: [],
    branch_offices_warehouses: [],
    models: [],
    contacts: [],
    voucher_types: [],
    params: params(),
    base_document: false,
    states: [
        {id: 1, text: 'Pendientes'},
        {id: 2, text: 'Aplicados'}
    ]
};



// WEBPACK FOOTER //
// ./src/modules/document_finder/state.js